'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'box-check';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f467';
var svgPathData = ['M48 176l0 240c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-240-352 0zm11-48l141 0 0-64-87.1 0c-5.2 0-10 2.5-13 6.7L59 128zm91.8 210.2c-9.2-9.5-8.9-24.7 .6-33.9 9.5-9.2 24.7-9 33.9 .6l16.1 16.6 59.3-81.6c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5L223.4 372.8c-4.2 5.7-10.7 9.3-17.8 9.8-7.1 .5-14-2.2-18.9-7.3l-35.9-37.2zM248 64l0 64 141 0-40.9-57.3c-3-4.2-7.9-6.7-13-6.7L248 64z', 'M335.1 16c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.7 10.8 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.8 42.8C72.9 26 92.3 16 112.9 16l222.1 0zM48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-240-352 0 0 240zM260.7 239.9c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5L223.4 372.8c-4.2 5.7-10.7 9.3-17.8 9.8-7.1 .5-14-2.2-18.9-7.3l-35.9-37.2c-9.2-9.5-8.9-24.7 .6-33.9 9.5-9.2 24.7-9 33.9 .6l16.1 16.6 59.3-81.6zM112.9 64c-5.2 0-10 2.5-13 6.7l-40.9 57.3 141 0 0-64-87.1 0zM248 128l141 0-40.9-57.3c-3-4.2-7.9-6.7-13-6.7l-87.1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;